import { configureStore } from '@reduxjs/toolkit';
import FlowerReducer from '../features/FlowerRedux/FlowerSlice';
import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import localforage from 'localforage';

const persistConfig={
  key: 'persist-store', 
  storage: localforage
}

const persistedReducer = persistReducer(persistConfig, FlowerReducer)
export const store = configureStore({
  reducer: {
    flowers: persistedReducer,
  },
});

export const persistor = persistStore(store);